export default __webpack_public_path__ + "static/media/white-avatar.c68e285d.png";